import { render, staticRenderFns } from "./dive.vue?vue&type=template&id=3077dd65&scoped=true&"
import script from "./dive.vue?vue&type=script&lang=js&"
export * from "./dive.vue?vue&type=script&lang=js&"
import style0 from "./dive.vue?vue&type=style&index=0&id=3077dd65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3077dd65",
  null
  
)

export default component.exports